module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/ffa-home-breakout-6c69c6b5174c713a18ce56e5bc6a3a5f.webp";